<bzg-sidebar-panel [title]="'MENU.SETTINGS' | translate">
  <bzg-sidebar-panel-item *ngFor="let menuItem of menuItems"
      [title]="'MENU_CATEGORY.' + (menuItem.Name | uppercase) | translate">
    <bzg-sidebar-panel-subitem *ngFor="let menuSubItem of menuItem.SubItems"
            [title]="'MENU.' + (menuSubItem.Name | uppercase) | translate"
            [routerLink]="getPath(menuSubItem.Name)"
            routerLinkActive
            #process1Active="routerLinkActive"
            [isActive]="process1Active.isActive">
    </bzg-sidebar-panel-subitem>
  </bzg-sidebar-panel-item>
</bzg-sidebar-panel>

